module.exports = __webpack_public_path__ + "static/pshot2-2aff9608ba75f045cbe4f32c5cc4f96a.gif";